var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.37 238.85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "left_svg__inner",
    fill: "#2d2a32",
    d: "M11.37 206.82l86.72-86.71-86.72-86.72 18.11-18.11-5.69-5.68L0 33.39l77 76.99 9.72 9.73L0 206.82l23.94 23.94 5.69-5.68-18.26-18.26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "left_svg__inner",
    fill: "#2d2a32",
    d: "M46.53 9.6l-5.68 5.68 104.97 104.98L41 225.08l5.68 5.68 110.51-110.5L46.53 9.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "left_svg__outer",
    d: "M86.94 238.85L60.8 213.6l92-95.27-95.28-92L83 0l121.37 117.27z",
    fill: "#2d2a32"
  })));
}

export default SvgLeft;